export default __webpack_public_path__ + "static/media/grafema_SET_02.febe7aeb.mp4";